<template>
  <div class="basic_wrap">
    <div class="nav_box">
      <!-- <div style="margin-left: 0.3rem">
        <svg
          width="1em"
          height="1em"
          fill=""
          aria-hidden="true"
          focusable="false"
          class="svg_left"
        >
          <symbol
            id="comm_icon_fh--svgSprite:all"
            viewBox="0 0 21.999 35.998"
          >
            <path
              id="comm_icon_fh--svgSprite:all_comm_icon_fh"
              d="M2209.279,137.564l-17.743-15.773a2.024,2.024,0,0,1-.271-.228,2.009,2.009,0,0,1,0-2.83,2.02,2.02,0,0,1,.274-.23l17.74-15.77a1.992,1.992,0,0,1,2.817,2.816l-16.422,14.6,16.422,14.6a1.992,1.992,0,0,1-2.817,2.817Z"
              transform="translate(-2190.681 -102.15)"
            />
          </symbol>
          <use xlink:href="#comm_icon_fh--svgSprite:all" />
        </svg>
      </div> -->
      <van-tabs
        v-model="active"
        class="van-tabs__wrap--scrollable"
        offset-top="1.2rem"
        lazy-render
        @change="tabChange"
      >
        <van-tab title="Eventos" />
        <van-tab title="Convidar" />
        <van-tab title="VIP" />
        <van-tab title="Rebate" />
        <van-tab title="Histórico" />
      </van-tabs>
    </div>
    <div v-if="active == 0" class="sideBox">
      <div class="tab_side">
        <div class="tab_side_title">
          <img
            src="https://front-n2.jingcdd.xyz/gjlm331/b208c95d-f370-4ceb-99ce-6e7ac6e7d511.png"
            alt=""
          />
          <div>Todos</div>
        </div>
        <div class="tab_his_title" @click="toHis">
          <div>Histórico</div>
        </div>
      </div>
      <div class="side_content" :style="{ height: screenHeight + 'px' }">
        <div
          v-for="(item, index) in activ_list"
          :key="index"
          class="side_img"
          @click="jump(item)"
        >
          <img :src="item.image" alt="" />
        </div>
      </div>
    </div>

    <div v-if="active == 1">
      <share />
    </div>
    <div v-if="active == 2">
      <cVip />
    </div>
    <div v-if="active == 3">
      <rebate />
    </div>
    <div v-if="active == 4">
      <history />
    </div>
    <ftNav />
  </div>
</template>
<script>
import Fetch from "../../utils/fetch";

import Vue from "vue";
import ftNav from "../../components/footer_nav/footer_nav";
import share from "../share/share.vue";
import cVip from "../vip/vip.vue";
import rebate from "../rebate/rebate.vue";
import history from "../history/history.vue";
import {
  Tab,
  Tabs,
  Progress,
  Empty,
  Dialog,
  Field,
  Sidebar,
  SidebarItem,
} from "vant";

Vue.use(Tab)
  .use(Tabs)
  .use(Progress)
  .use(Empty)
  .use(Dialog)
  .use(Field)
  .use(Sidebar)
  .use(SidebarItem);
export default {
  name: "Activity",
  components: {
    ftNav,
    share,
    cVip,
    rebate,
    history,
  },
  data() {
    return {
      is_open: false,
      bonus: 0.0,
      activeItem: [],
      group_service: null,
      active: 0,
      sidebar_active: 0,
      activ_list: [],
      timer: false,
      screenHeight: "",
    };
  },
  watch: {
    screenHeight(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenHeight);
          that.timer = false;
        }, 400);
      }
    },
  },
  created() {
    this.$bus.$emit("send2ftnav", 1);
  },
  beforeDestroy() {},
  mounted() {
    this.getActivity();
    const activeId = Number(this.$route?.query?.tab) || 0;
    this.tabChange(activeId);
    var that = this;
    window.screenHeight = document.body.clientHeight - 110;
    that.screenHeight = window.screenHeight;
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight - 110;
        that.screenHeight = window.screenHeight;
        // console.log(that.screenHeight);
      })();
    };
  },
  methods: {
    tabChange(v) {
      this.active = v;
    },
    toHis() {
      this.active = 4;
    },
    getActivity() {
      Fetch("/Article/getArticle").then((r) => {
        this.activ_list = r.data;
      });
    },
    jump(item) {
      if (item.id == 41) {
        this.active = 1;
      } else {
        this.$router.push({
          path: "/article",
          query: { content: item.content, title: item.title },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";
.nav_box {
  // width: 95%;
  background-color: @secondary-color;
  // display: flex;
  // align-items: center;
  // margin: 0 auto 0.2rem auto;
}
/deep/ .van-nav-bar--fixed {
  z-index: 2;
}
/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}
/deep/.van-tab__text {
  font-size: 0.3rem;
  color: #fff;
}
/deep/.van-tabs__line {
  background: @ButtonColor;
  height: 0.04rem;
}
@media (min-width: @maxWidth) {
  :deep(.van-sticky) {
    position: static !important;
  }
}
/deep/ .van-tabs__nav {
  padding-left: 0;
  padding-right: 0;
  background-color: @secondary-color;
}


.btimg {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
.tab_side {
  display: flex;
  flex-direction: column;
  // padding-left: 0.4rem;
  width: 25%;
  .tab_side_title {
    width: 2rem;
    height: 1.3rem;
    background-color: @rechargeColor;
    border-radius: 0.3rem;
    text-align: center;
    margin: 0 auto;
    margin-top: 0.3rem;
    img {
      width: 0.6rem;
      margin-top: 0.1rem;
    }
    div {
      color: @activityColor;
      font-size: 0.2rem;
      margin-top: 0.2rem;
    }
  }
  .tab_his_title {
    width: 1.8rem;
    height: 0.8rem;
    background-color: @rechargeColor;
    border-radius: 0.3rem;
    text-align: center;
    margin: 0 auto;
    margin-top: 0.3rem;
    div {
      color: @activityColor;
      font-size: 0.28rem;
      margin-top: 0.22rem;
    }
  }
}
.svg_left {
  fill: @textcolor1;
}
.sideBox {
  display: flex;

  .side_content {
    width: 75%;
    height: 100%;
    overflow-y: auto;
    .side_img {
      width: 95%;
      background-color: @secondary-color;
      text-align: center;
      margin-top: 0.2rem;
      padding: 0.1rem;
      img {
        width: 95%;
      }
    }
  }
}
.aitwrap {
  width: 100%;
  overflow: hidden;
  position: relative;
  max-height: 100vh;
  //height: 100%;
}

.myteam-bg {
  width: 100%;
  height: 3rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.aitem_l {
  width: 22%;
  float: left;
  padding: 0.5rem 0 0 2%;
}

.l_one {
  display: block;
  padding: 0.1rem 0;
  background-color: #f9b818;
  color: #000000;
  text-align: center;
  border-radius: 0.2rem;
  width: 80%;
  margin: 0 auto;
}

.l_one img {
  width: 0.55rem;
  margin-bottom: 0.1rem;
}

.l_two {
  display: block;
  padding: 0.2rem 0;
  background-color: #999999;
  color: #fff;
  text-align: center;
  border-radius: 0.1rem;
  font-size: 0.24rem;
  width: 80%;
  margin: 0.2rem auto;
}

.l_three {
  display: block;
  padding: 0.2rem 0;
  background-color: #f9b818;
  color: #000000;
  text-align: center;
  border-radius: 0.1rem;
  font-size: 0.24rem;
  width: 80%;
  margin: 0.2rem auto;
}

.aitem_r {
  width: 100%;
  height: calc(100vh - 2.3rem);
  float: right;
  // overflow-y: scroll;
  overflow-x: hidden;
}

.details {
  text-align: center;
  margin-top: 10px;
  color: #82a504;
  font-size: 16px;
  font-weight: 600;
}

.box-wrap {
  position: relative;
}

.bonus {
  text-align: center;
  font-size: 0.8rem;
  color: gold;
  position: absolute;
  bottom: 10px;
  width: 100%;
  font-weight: 700;
  // left: 41%;
}

.box {
  width: 60%;
  height: auto;
  display: block;
  margin: 20% auto 18px;
}

.open-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  //background-color: rgba(0, 0, 0, 0.5);
  background: #0e4114;
  z-index: 3;
}

.ades {
  margin-top: 10px;
  font-size: 0.37rem;
  color: rgba(255, 255, 255, 0.737);
  line-height: 20px;
  text-indent: 10px;
}

.aname {
  font-size: 0.33rem;
  line-height: 18px;
  color: #88b19f;
}

.aitem {
  width: 100%;
  // height: 3rem;
  position: relative;
  padding-bottom: 0.2rem;
  background-color: @secondary-color;
  box-sizing: border-box;
  padding: 0.15rem;
  margin-bottom: 0.2rem;
  border-radius: 0.2rem;
}

.basic_wrap {
  background-color: @activityColor;
  min-height: 100vh;
  width: 100%;
}

.daily-gift {
  position: absolute;
  width: 2rem;
  bottom: 55px;
  left: 10px;
  z-index: 2;
  animation: my-btn 0.9s ease-in infinite;
}

.telegram {
  position: absolute;
  width: 1.3rem;
  bottom: 66px;
  right: 20px;
  z-index: 2;
  // background: white;
  // border-radius: 80%;
  // overflow: hidden;
  // animation: my-btn 0.9s ease-in infinite;
}

@keyframes my-btn {
  0% {
    transform: translateX(0 rpx);
    transform: scale(0.8);
  }

  50% {
    transform: translateX(20 rpx);
    transform: scale(1);
  }

  100% {
    transform: translateX(0 rpx);
    transform: scale(0.8);
  }
}
</style>
